import {useCompleteLocation} from '@aboutyou/router';
import React, {useEffect} from 'react';
import {useAuthLogger} from '../hooks/useAuthLogger';

export const LogLegacyFacebookStuckInPopup = () => {
  const {Log, isLogInstanceLoading} = useAuthLogger();
  const locationHash = useCompleteLocation().hash;

  const isFacebookPopupStuck =
    locationHash?.match('#cb=') &&
    locationHash?.includes('graph_domain=facebook');

  const alreadyLoggedRef = React.useRef(false);

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    if (
      isLogInstanceLoading ||
      alreadyLoggedRef.current ||
      !isFacebookPopupStuck
    ) {
      return;
    }

    Log({
      event: 'sso-fe-error',
      attributes: {
        idp: 'legacy-facebook',
        idp_key: 'legacy-facebook',
        reason: 'popup-stuck',
      },
      state: null,
    });

    alreadyLoggedRef.current = true;
  }, [Log, isLogInstanceLoading, isFacebookPopupStuck, locationHash]);

  return null;
};
